// extracted by mini-css-extract-plugin
module.exports = {"item":"_1kTYJo","preview":"T1ndgw","upchargePrice":"_2Y5tru","brand":"_2RWYYu","addInfoCapitaliseFirstLetter":"Q81ZS6","name":"_3LiwgQ"};